// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import styled, { css } from "styled-components";

const baseDisplayStyles = css`
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    border: 0;
    padding: 0;
`;

const variantDisplayStyles = {
    medium: css`
        ${baseDisplayStyles}
        width: calc(50% - 1rem);
    `,
    small: css`
        ${baseDisplayStyles}
        width: calc(33% - 1rem);
    `,
    large: css`
        ${baseDisplayStyles}
        width: calc(100% - 1rem);
    `,
    verySmall: css`
        ${baseDisplayStyles}
        width: calc(22% - 1rem);
    `,
};
const StyledLabel = styled.label`
    min-height: 1.375rem;
    display: inline-block;
    width: 100%;
    font-weight: 700;
    line-height: 1.375;
    font-size: ${pxToRem(14)};
`;

interface StepFormTextFieldProps {
    label: string;
    value: string;
    variant?: keyof typeof variantDisplayStyles;
    error?: string;
}
const TextBox = styled(Typography)<{ error?: string }>`
    font-size: 14px;
    padding-block: 0.625rem;
    padding-inline: ${pxToRem(10)};
    border: 1px solid
        ${props =>
            props.error
                ? css`
                      ${getColor("danger.main")}
                  `
                : css`
                      ${getColor("text.accent")}
                  `};

    height: ${pxToRem(44)};
    border-radius: ${pxToRem(4)};
`;

const ErrorMessage = styled(Typography)`
    font-size: ${pxToRem(12)};
    padding-top: ${pxToRem(4)};
    color: ${getColor("danger.main")};
    font-weight: ${({ theme }) => theme.design.typography.weight.medium};
`;
const StepFormTextDisplayValues: React.FC<StepFormTextFieldProps> = ({ label, value, variant = "medium", error }) => {
    const displayStyles = variantDisplayStyles[variant];

    return (
        <StyledWrapper css={displayStyles}>
            <StyledLabel>{label} </StyledLabel>
            <TextBox error={error}>{value}</TextBox>
            <ErrorMessage>{error}</ErrorMessage>
        </StyledWrapper>
    );
};

export default StepFormTextDisplayValues;
